module.exports = __webpack_public_path__ + "img/pedreiro.638ba011.png";